import React, { useState, useMemo } from "react";
import ReactMapGL, { NavigationControl, ScaleControl, Source, Layer, WebMercatorViewport, LinearInterpolator } from "react-map-gl";
import Map2Control from "./Map2Control";
import mapboxgl from "mapbox-gl";
import Logo from "../Logo";
import MapboxLogo from "../mapboxLogo"
import { stateHighlight } from "./Map2StateStyle";
import bbox from '@turf/bbox';
import LegendAg from "./LegendAg";
import LegendTransport from "./LegendTransport";
import LegendUrban from "./LegendUrban";
import { MAPBOX_TOKEN } from "../../config";

import "./Map2.css";

// eslint-disable-next-line import/no-webpack-loader-syntax
mapboxgl.workerClass = require("worker-loader!mapbox-gl/dist/mapbox-gl-csp-worker").default;

const mapboxToken = MAPBOX_TOKEN

const Map2 = (props) => {
  const [mapStyle, setMapStyle] = useState(
    "mapbox://styles/mapbox/satellite-v9"
  );
  const setGraphData = props.setGraphData;
  const graphData = props.graphData;
  const setOpen2 = props.setOpen;
  const [viewport, setViewport] = useState({
    latitude: 38.3283,
    longitude: -98.579576,
    zoom: 3.95,
    // width: "100vw",
    // height: "93.1vh",
  });
  const [state, setState] = React.useState({
    a: true,
    t: true,
    u: true,
  });

  const navControlStyle = {
    right: 10,
    top: 10,
  };

  const scaleControlStyle = {
    right: 10,
    bottom: 108,
  };

  const onClick = (event) => {
    setGraphData(event.features[0]);
    setOpen2(true);
    console.log("map2 click event", event)
    const feature = event.features[0];
    if (feature) {
      // calculate the bounding box of the feature
      const [minLng, minLat, maxLng, maxLat] = bbox(feature);
      // construct a viewport instance from the current state
      const vp = new WebMercatorViewport(viewport);
      const {longitude, latitude, zoom} = vp.fitBounds(
        [
          [minLng, minLat],
          [maxLng, maxLat]
        ],
        {
          padding: 250
        }
      );
      setViewport({
        ...viewport,
        longitude,
        latitude,
        zoom,
        transitionInterpolator: new LinearInterpolator({
          around: [event.offsetCenter.x, event.offsetCenter.y]
        }),
        transitionDuration: 1000
      });
    }
  }

  const selectedState = (graphData && graphData.properties.NAME) || '';
  const filter = useMemo(() => ['in', 'NAME', selectedState], [selectedState]);
  
  return (
    <>
      <ReactMapGL
        {...viewport}
        onViewportChange={(viewport) => setViewport(viewport)}
        mapboxApiAccessToken={mapboxToken}
        mapStyle={mapStyle}
        mapOptions={{ logoPosition: "bottom-right" }}
        height='100%'
        width='100%'
        onClick={onClick}
        interactiveLayerIds={['summaryStats']}
      >
        <NavigationControl style={navControlStyle} showCompass={false} />
        <ScaleControl
          maxWidth={100}
          unit="metric"
          style={scaleControlStyle}
          className="scaleControl"
        />

          <Source type="vector" tiles={["https://lumonitor.blob.core.windows.net/tiles/summary_stats/{z}/{x}/{y}.pbf"]}>
            <Layer {...stateHighlight} filter={filter} />
          </Source>

        <div className="flex-container">
          <div className="map2LegendFlex">
            {state.a === true && <LegendAg/>}
            {state.t === true && <LegendTransport />}
            {state.u === true && <LegendUrban />}
          </div>
        </div>
      </ReactMapGL>
      <Map2Control onChange={setMapStyle} state={state} setState={setState} />

      <Logo className="fullScreenLogo" height={70} width={175}>
      </Logo>
      <MapboxLogo />
    </>
  );
};

export default Map2;